import React from 'react';
import { useFilterLayoutStyles } from '../utils/languageUtils';

interface FilterGroupRowProps {
    label: string;
    required?: boolean;
    spanClassName?: string;
    className?: string;
    forceHorizontal?: boolean;
    childWidths?: string[];
    children: React.ReactNode;
}

/**
 * 共享 label 的筛选器行容器
 * @description 多个筛选组件共享一个 label，children 平分内容区域
 */
const FilterGroupRow: React.FC<FilterGroupRowProps> = ({
    label,
    required = false,
    spanClassName,
    className,
    forceHorizontal,
    childWidths,
    children,
}) => {
    const { containerClassName, labelClassName, inputContainerClassName } = useFilterLayoutStyles(spanClassName, className, forceHorizontal);

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </span>
            <div className={inputContainerClassName}>
                <div className="flex w-full">
                    {React.Children.map(children, (child, index) => (
                        <div
                            className="min-w-0"
                            style={childWidths?.[index] ? { width: childWidths[index] } : { flex: 1 }}
                        >
                            {child}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FilterGroupRow;
